import React from "react";

import urlConfig from "../../urlConfig";


const MenuOverlay = ({ visible, onClose }) => {
  const links = [
    { href: urlConfig.aboutUs, label: "About Us" },
    { href: urlConfig.buyEon, label: "Buy $EON" },
    { href: urlConfig.documentation, label: "Docs" },
    { href: urlConfig.tokenomics, label: "Tokenomics" },
    { href: urlConfig.roadmap, label: "Roadmap" },
    { href: urlConfig.lore, label: "Lore" },
  ];

  return (
    // Outer backdrop covering the full viewport.
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-50 transition-opacity duration-500 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={onClose}
    >
      {/* Menu container (80% of the viewport height, full width) */}
      <div
        className={`w-full h-4/5 bg-[#131220] transition-transform duration-500 ${
          visible ? "translate-y-0" : "-translate-y-full"
        }`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside.
      >
        <div className="container mx-auto px-4 lg:px-32 py-8 h-full flex flex-col">
          {/* Close Button */}
          <div className="flex justify-end">
            <button onClick={onClose} className="text-white text-5xl">
              &times;
            </button>
          </div>
          {/* Navigation and Community Sections */}
          <div className="flex flex-col lg:flex-row justify-between items-center flex-grow">
            {/* Left: Navigation Links */}
            <div className="grid grid-flow-col grid-rows-3 gap-10">
              {links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  rel="noopener noreferrer"
                  className="block text-white text-2xl md:text-4xl font-extrabold hover:text-[#EF4E5D]"
                >
                  {link.label}
                </a>
              ))}
            </div>
            {/* Right: Join the Community */}
            <div className="mt-8 lg:mt-0">
              <div className="flex flex-col items-center">
                <p className="text-white text-2xl md:text-4xl font-extrabold">
                  Join the Community
                </p>
                <div className="flex justify-center space-x-8 mt-4">
                  <a
                    href={urlConfig.telegram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-[#EF4E5D]"
                  >
                    <i className="pi pi-telegram text-2xl md:text-4xl"></i>
                  </a>
                  <a
                    href={urlConfig.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:text-[#EF4E5D]"
                  >
                    <i className="pi pi-twitter text-2xl md:text-4xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* Bottom Section for Terms & Privacy Links (smaller text) */}
          <div className="mt-8 text-center">
            <div className="flex justify-center space-x-4">
              <a
                href={urlConfig.termsAndConditions}
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-sm"
              >
                Terms &amp; Conditions
              </a>
              <a
                href={urlConfig.privacyPolicy}
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#EF4E5D] transition duration-200 text-sm"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuOverlay;